// WorkspaceMembers.js

const asTrimmedString = (value) => String(value || '').trim();

const firstNonEmptyString = (...values) => {
    for (const value of values) {
        const text = asTrimmedString(value);
        if (text) return text;
    }

    return '';
};

export const getWorkspaceMemberKey = (member, userNode = null) => {
    return firstNonEmptyString(
        member?.userKey,
        member?.key,
        member?.user?.userKey,
        member?.user?.key,
        userNode?.key
    );
};

export const buildWorkspaceMemberProfile = (member, userNode = null) => {
    const summary = member?.user || {};
    const key = getWorkspaceMemberKey(member, userNode);

    const name = firstNonEmptyString(
        userNode?.data_profile?.name,
        userNode?.title,
        summary?.name,
        member?.title,
        member?.email,
        key
    );

    const email = firstNonEmptyString(
        userNode?.data_profile?.email,
        userNode?.email,
        member?.email,
        summary?.email
    );

    const title = firstNonEmptyString(
        member?.title,
        summary?.title,
        name,
        email,
        key
    );

    const coverUrl = firstNonEmptyString(
        userNode?.coverUrl,
        userNode?.data_profile?.coverUrl,
        member?.coverUrl,
        summary?.coverUrl,
        member?.data_profile?.coverUrl
    ) || null;

    const coverStoragePath = firstNonEmptyString(
        userNode?.coverStoragePath,
        userNode?.storagePath,
        member?.coverStoragePath,
        summary?.coverStoragePath,
        member?.storagePath,
        summary?.storagePath
    ) || null;

    const storagePath = firstNonEmptyString(
        userNode?.storagePath,
        member?.storagePath,
        summary?.storagePath,
        coverStoragePath
    ) || null;

    return {
        ...summary,
        ...member,
        key,
        userKey: key,
        name,
        title,
        email,
        coverUrl,
        coverStoragePath,
        storagePath,
        data_profile: {
            ...(summary?.data_profile || {}),
            ...(member?.data_profile || {}),
            name,
            email,
            coverUrl,
            coverStoragePath,
        },
    };
};

export const getWorkspaceMemberDisplayName = (member, userNode = null) => {
    const profile = buildWorkspaceMemberProfile(member, userNode);
    return firstNonEmptyString(profile?.title, profile?.name, profile?.email, profile?.userKey);
};
